import React from "react";
import moment from "moment";

// Components
import TextInput from "components/input/TextInput";
import SignatureInput from "components/input/SignatureInput";
import SelectInput from "components/input/SelectInput";

// Data
import {
  instructions,
  declarations,
  how_do_you_find_us_options,
} from "utils/constants/data";

function Declaration({
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  handleBlur,
  signatureRef,
  handleClear,
  handleSave,
}) {
  return (
    <div className="bg-white rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6">
      <p className="uppercase text-xl sm:text-2xl mb-2 md:mb-4 font-bold">
        Declaration
      </p>
      <hr className="h-1 border-none text-[#333] bg-[#333]" />
      <div className="space-y-4">
        <ol className="list-decimal space-y-6 ml-3 text-justify text-base xl:text-lg">
          {instructions.map((instruction, i) => {
            return <li key={i}>{instruction.desc}</li>;
          })}
        </ol>
      </div>
      <div className="flex flex-col space-y-4">
        {declarations.map((declaration, i) => {
          return (
            <div className="flex flex-col">
              <div className="w-full ml-4 flex flex-row items-center space-x-4">
                <div>
                  <input
                    checked={values[`is_declaration_${i + 1}_checked`] === true}
                    id={`declaration-${i + 1}-radio-btn`}
                    name={`declaration-${i + 1}`}
                    type="checkbox"
                    onChange={() =>
                      setFieldValue(
                        `is_declaration_${i + 1}_checked`,
                        !values[`is_declaration_${i + 1}_checked`],
                      )
                    }
                    value={values[`is_declaration_${i + 1}_checked`]}
                    className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                  />
                </div>
                <div className="text-base xl:text-lg" key={i}>
                  {declaration.title}
                </div>
              </div>
              {errors[`is_declaration_${i + 1}_checked`] &&
                touched[`is_declaration_${i + 1}_checked`] &&
                errors[`is_declaration_${i + 1}_checked`] && (
                  <p className="ml-4 text-xs md:text-sm text-red-500">
                    {errors[`is_declaration_${i + 1}_checked`]}
                  </p>
                )}
            </div>
          );
        })}
      </div>
      <div className="flex flex-col space-y-2">
        <div className="font-semibold flex text-base xl:text-lg">
          <p>How did you find out about us:</p>
        </div>
        <SelectInput
          name="how_do_you_find_us"
          classNameInput="text-base xl:text-lg"
          options={how_do_you_find_us_options}
          onChange={handleChange}
          onBlur={handleBlur}
          error={
            errors?.how_do_you_find_us &&
            touched?.how_do_you_find_us &&
            errors.how_do_you_find_us
          }
          value={values.how_do_you_find_us}
        />
        {(values.how_do_you_find_us === "Student Referral" ||
          values.how_do_you_find_us === "Past Student" ||
          values.how_do_you_find_us === "Other") && (
          <TextInput
            name="specified_how_do_you_find_us"
            label={`${values.how_do_you_find_us} – Please Specify:`}
            placeholder="Fill in specific reason..."
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              errors?.specified_how_do_you_find_us &&
              touched?.specified_how_do_you_find_us &&
              errors.specified_how_do_you_find_us
            }
            value={values.specified_how_do_you_find_us}
          />
        )}
      </div>
      <TextInput
        name="participant_name"
        label="Participant Name:"
        placeholder="Fill in your name..."
        onChange={handleChange}
        onBlur={handleBlur}
        error={
          errors?.participant_name &&
          touched?.participant_name &&
          errors.participant_name
        }
        value={values.participant_name}
      />
      <SignatureInput
        name="participant_signature"
        label="Participant Signature:"
        signatureRef={signatureRef}
        signatureDataURL={values.participant_signature}
        handleSave={handleSave}
        handleClear={handleClear}
        error={
          errors?.participant_signature &&
          touched?.participant_signature &&
          errors.participant_signature
        }
        descriptionText="Signature is required, please fill in your signature within the box provided below"
      />

      <div className="flex flex-col">
        <div className="w-full  flex flex-row items-center space-x-4">
          <div>
            <input
              checked={values[`is_privacy_notice_checked`] === true}
              id={`privacy_notice_checked-radio-btn`}
              name={`privacy_notice_checked`}
              type="checkbox"
              onChange={() =>
                setFieldValue(
                  `is_privacy_notice_checked`,
                  !values[`is_privacy_notice_checked`],
                )
              }
              value={values[`is_privacy_notice_checked`]}
              className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
            />
          </div>
          <div className="text-sm sm:text-base md:text-lg">
            I have read and agree to the{" "}
            <a
              className="underline font-bold"
              href="/privacy-notice"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Notice.
            </a>{" "}
          </div>
        </div>
        {errors[`is_privacy_notice_checked`] &&
          touched[`is_privacy_notice_checked`] &&
          errors[`is_privacy_notice_checked`] && (
            <p className="text-xs md:text-sm text-red-500">
              {errors[`is_privacy_notice_checked`]}
            </p>
          )}
      </div>
      <div className="flex flex-col space-y-2">
        <div className="font-semibold flex text-base xl:text-lg">
          <p>Registration Date:</p>
        </div>
        <div className="flex text-base xl:text-lg">
          <p>{moment().format("dddd, DD MMMM YYYY")}</p>
        </div>
      </div>
      <p className="text-xs md:text-md italic">
        One copy of this signed form will be retained by ITS as part of the
        participant’s records. A 2nd copy of this signed form should be retained
        by the participant.
      </p>
    </div>
  );
}

export default Declaration;
